// src/components/bot/components/ResponseTypeSection.tsx
// 🎨 RESPONSE TYPE TOGGLE - Template vs Questionnaire Mode (80 lines)

import React from 'react';
import styles from '../BotForm.module.css';
import logger from '../../../utils/logger';

interface ResponseTypeSectionProps {
  responseType: 'template' | 'questionnaire';
  onResponseTypeChange: (responseType: 'template' | 'questionnaire') => void;
}

const ResponseTypeSection: React.FC<ResponseTypeSectionProps> = ({
  responseType,
  onResponseTypeChange
}) => {
  logger.log('🎯 ResponseTypeSection: Rendered with type:', responseType);

  // 🔥 HANDLE SELECTION: Switch response types
  const handleTypeSelection = (type: 'template' | 'questionnaire') => {
    logger.log('🔄 ResponseTypeSection: Switching to:', type);
    onResponseTypeChange(type);
  };

  return (
    <div className={styles.sectionWide}>
      <h3>Response Type</h3>
      
      <div className={styles.responseTypeContainer}>
        
        {/* 🎯 TEMPLATE MODE */}
        <div 
          className={`${styles.responseOption} ${responseType === 'template' ? styles.active : ''}`}
          onClick={() => handleTypeSelection('template')}
        >
          <div className={styles.optionIcon}>🎯</div>
          <div>
            <div className={styles.optionTitle}>Single Template</div>
            <div className={styles.optionDesc}>Send one template immediately</div>
          </div>
        </div>
        
        {/* 🎯 QUESTIONNAIRE MODE */}
        <div 
          className={`${styles.responseOption} ${responseType === 'questionnaire' ? styles.active : ''}`}
          onClick={() => handleTypeSelection('questionnaire')}
        >
          <div className={styles.optionIcon}>📋</div>
          <div>
            <div className={styles.optionTitle}>Ask Questions First</div>
            <div className={styles.optionDesc}>Collect info then send template</div>
          </div>
        </div>
        
      </div>

      {/* 🎯 MODE EXPLANATION */}
      <div className={styles.modeExplanation}>
        {responseType === 'template' ? (
          <div className={styles.explanationText}>
            <i className="fas fa-info-circle" style={{ color: '#3b82f6' }}></i>
            <span>
              <strong>Template Mode:</strong> Bot will immediately send the selected WhatsApp template 
              when users message with your keywords. Perfect for instant responses and information sharing.
            </span>
          </div>
        ) : (
          <div className={styles.explanationText}>
            <i className="fas fa-info-circle" style={{ color: '#f59e0b' }}></i>
            <span>
              <strong>Questionnaire Mode:</strong> Bot will first ask a series of questions to collect 
              user information, then send the template. Great for lead qualification and data collection.
            </span>
          </div>
        )}
      </div>
      
    </div>
  );
};

export default ResponseTypeSection;